
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ZBreadcrumb',
  props: {
    separator: {
      type: String,
      default: '/'
    }
  },
  provide() {
    return {
      breadcrumbSeparator: this.separator
    }
  }
})
